import { TIERS } from "constants/pricing";
import {
  ENGLISH_LOCALE_ID,
  SPANISH_LOCALE_ID,
  FRENCH_LOCALE_ID,
  GERMAN_LOCALE_ID,
  PORTUGEESE_LOCALE_ID,
  JAPANESE_LOCALE_ID
} from "constants/localization";

export const LEARN_MORE_VIDEOS_BY_LOCALE_AND_TIER = {
  [ENGLISH_LOCALE_ID]: { [TIERS.STANDARD]: "AJZPfiy4MvQ", [TIERS.PRO]: "EktHUKbOjVU" },
  [SPANISH_LOCALE_ID]: { [TIERS.STANDARD]: "pc3pyOJ2nYI", [TIERS.PRO]: "_3poht9VbHA" },
  [FRENCH_LOCALE_ID]: { [TIERS.STANDARD]: "e0L8cjyQdgM", [TIERS.PRO]: "uzEuF0sPqpM" },
  [PORTUGEESE_LOCALE_ID]: { [TIERS.STANDARD]: "QQBtWCk-HQU", [TIERS.PRO]: "_QqhH-BMncM" },
  [GERMAN_LOCALE_ID]: { [TIERS.STANDARD]: "diS3_WWhG30", [TIERS.PRO]: "Ahdwi6K3K_o" },
  [JAPANESE_LOCALE_ID]: { [TIERS.STANDARD]: "3EVQBrQZfJU", [TIERS.PRO]: "OksNX5QN62c" }
};

export const getVideoIdByLocaleAndTier = (locale, tier) => {
  const fallback = LEARN_MORE_VIDEOS_BY_LOCALE_AND_TIER[ENGLISH_LOCALE_ID][tier];
  return LEARN_MORE_VIDEOS_BY_LOCALE_AND_TIER[locale]?.[tier] ?? fallback;
};

export const hasLearnMoreVideo = function (tier) {
  return tier in LEARN_MORE_VIDEOS_BY_LOCALE_AND_TIER[ENGLISH_LOCALE_ID];
};
